export default {
  ctaLabel: 'Fork on GitHub'
};